// combatpro/panels/spells/SpellWorkspace.js
//
// Combat PRO - SpellWorkspace (functional migration of the spell system).
//
// Composes the full spells-block from battletracker.html, reproducing its DOM
// exactly from the extracted child components:
//   spells-block-{index} (vi-dom-hidden)
//     spells-section
//       SpellToolbar          (vi-section-hdr-row: title + Random/Add buttons)
//       vi-spell-cards-wrapper
//         vi-spell-cards
//           SpellCard x3       (Auto Populate / Customise Spells / Random Spell)
//       SpellSlots            (the [0,1,2] spell-row loop)
//
// The block id is computed from the index prop exactly as the template
// interpolated it. The three info-card texts are passed to SpellCard verbatim
// from the source. All handlers are received as props and forwarded to the
// children only; none are implemented here.
//
// Imports only React and the child components. No state, hooks, or business
// logic. Do not edit battletracker.html.
//
// Stage 48B-3 (Spell Workspace Integration): a single optional `mounted` prop is
// added so the integration layer can render this block in its visible state. When
// the prop is omitted (every existing/extraction context), the root keeps the
// original `vi-dom-hidden` class and the DOM is byte-identical to before. When
// mounted={true}, the root drops `vi-dom-hidden` so the block renders visible -
// reproducing the legacy reveal where vi_mountSpells set block.style.display =
// 'block' (battletracker.html 10069). No other change; no styling added here.

import React from 'react';
import SpellToolbar from './SpellToolbar';
import SpellCard from './SpellCard';
import SpellSlots from './SpellSlots';

function SpellWorkspace(props) {
  const index = props.index;
  const rootClassName = props.mounted ? '' : 'vi-dom-hidden';
  return (
    <div id={`spells-block-${index}`} className={rootClassName}>
      <div className="spells-section">
        <SpellToolbar
          index={index}
          onRandomSpell={props.onRandomSpell}
          onAddSpell={props.onAddSpell}
        />
        <div className="vi-spell-cards-wrapper">
          <div className="vi-spell-cards">
            <SpellCard
              title="Auto Populate"
              body="Instantly assigns the most commonly used spells for this monster so you can start combat immediately without setup."
              foot="Best for quick encounters"
            />
            <SpellCard
              title="Customise Spells"
              body="Manually replace any spell using the dropdown to control exactly what abilities this monster can use in combat."
              foot="Full control over behaviour"
            />
            <SpellCard
              title="Random Spell"
              body="Generate new spell combinations instantly to create variation without needing to manually select each ability."
              foot="Fast variation and testing"
            />
          </div>
        </div>
        <SpellSlots
          index={index}
          onSpellChange={props.onSpellChange}
          onCastRoundChange={props.onCastRoundChange}
          onClearSpell={props.onClearSpell}
          onEditSpell={props.onEditSpell}
        />
      </div>
    </div>
  );
}

export default SpellWorkspace;
